module.exports = __webpack_public_path__ + "cc9fa5cc.ttf";